import * as _ from 'lodash'
import moment from 'moment'
import Tolls from '../../../services/toll'
import {beforeOneYear} from '../../../validators/date';
import * as F from '../../../filters/date';

import Pagination, {
  Page
} from '../../../components/pagination';

export default {
  data() {
    return {
      loading: Promise.resolve(true),
      page: new Page(),
      saldoVeiculo: undefined,
      searchState: 'NEW',
      plate: undefined,
      messageError:undefined
    }
  },
  computed: {
    contractId: function(){
      
      return this.$route.params.contractId;
    },
  },
  methods: {
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.find();
    },
    find() {
      let promise = Tolls.getSaldoVeiculo(this.plate).then(data => {
        if (data) {
          this.saldoVeiculo = data;
          
          // this.searchState = this.data.summaries && 'FOUND' || 'NOTFOUND';
          this.searchState = 'FOUND';
          // this.page = this.page.itemCount(data.paginatorResult.totalRecords);
        }

        // if (data && data.summaries && data.summaries.summary) {
        //   data.summaries.summary = _.sortBy(data.summaries.summary, s => s.historic);
        // }

        this.$nextTick( () => {
          $('[data-toggle="tooltip"]').tooltip();
          $('html, body').stop().animate({
            scrollTop: $("#resumeTable").offset().top-110
          }, 1000);
        });

      }).catch(err => {
        this.searchState = 'NOTFOUND';
      });
      this.$store.dispatch('loading', promise);
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/toll-ticket/balance-statement.js